export const GET_CONTENT_INIT = 'GET_CONTENT_INIT';
export const GET_CONTENT_SUCCESS = 'GET_CONTENT_SUCCESS';
export const GET_CONTENT_ERROR = 'GET_CONTENT_ERROR';

export const GET_CONTENT_SERIE_INIT = 'GET_CONTENT_SERIE_INIT';
export const GET_CONTENT_SERIE_SUCCESS = 'GET_CONTENT_SERIE_SUCCESS';
export const GET_CONTENT_SERIE_ERROR = 'GET_CONTENT_SERIE_ERROR';

export const GET_CONTENT_PBI_INIT = 'GET_CONTENT_PBI_INIT';
export const GET_CONTENT_PBI_SUCCESS = 'GET_CONTENT_PBI_SUCCESS';
export const GET_CONTENT_PBI_ERROR = 'GET_CONTENT_PBI_ERROR';
export const CLEAR_CONTENT_PBI = 'CLEAR_CONTENT_PBI';

export const CLEAR_VCARD_DATA = 'CLEAR_VCARD_DATA';

export const GET_SEEN_LAST = 'GET_SEEN_LAST';
export const CLEAR_SEEN_LAST = 'CLEAR_SEEN_LAST';
export const GET_SEEN_LAST_INIT = 'GET_SEEN_LAST_INIT';

export const UNLOCK_VOD_CONTENT = 'UNLOCK_VOD_CONTENT';
export const CLEAR_UNLOCK_VOD_CONTENT = 'CLEAR_UNLOCK_VOD_CONTENT';
